import type { PropertiesNullable } from '@@types/helpers'
import EntityBase from '@app/entities/EntityBase'
import { ensureArray } from '@libs/ensureArray'
import type {
  AttacksSummary,
  AttacksSummaryCard,
  AttacksSummaryLayout,
  Maybe
} from '@server/graphql/typeDefs/types'
import { createEntities } from '.'
import EntityAttacksSummaryCard from './EntityAttacksSummaryCard'

export default class EntityAttacksSummary
  extends EntityBase
  implements PropertiesNullable<AttacksSummary>
{
  layout: Maybe<AttacksSummaryLayout> = null
  cards: Maybe<AttacksSummaryCard[]> = null

  constructor(data: Partial<AttacksSummary>) {
    super()
    Object.assign(this, data)
  }

  get cardEntities(): EntityAttacksSummaryCard[] {
    return createEntities<AttacksSummaryCard, EntityAttacksSummaryCard>(
      EntityAttacksSummaryCard,
      ensureArray(this.cards)
    )
  }
}
